import LeftReview from "../../../components/ui/reviews/LeftReview";
import { useContentHeightCalculation } from "../../../hooks/useContentHeightCalculation";

function PlaintrReviewV2() {
  const { contentRef, mainRef } = useContentHeightCalculation();
  
  return (
    <div className="main-content-area" ref={mainRef}>
      <div className="content" ref={contentRef}>
        <LeftReview />
      </div>
    </div>
  );
}

export default PlaintrReviewV2;
